// extracted by mini-css-extract-plugin
export default {"modalOverlay":"JH-z","modalContent":"KH-z","header":"LH-z","close":"MH-z"};